import React from 'react';
import styles from '../FileSelect.module.css';
import { IoClose, IoPlay, IoSave } from 'react-icons/io5';
import classNames from 'classnames';

export default function SelectedFileControl({ file, progress, onClear, onPlay, onSave }) {
  if (file)
    return (
      <div className="flex-fill align-self-stretch d-flex flex-column justify-content-center align-items-stretch px-5">
        <div className="d-flex justify-content-between align-items-baseline">
          <p>{file.name}</p>
          <button onClick={onClear}>
            <IoClose size={25} />
          </button>
        </div>

        <div className="progress" style={{ height: 20 }}>
          <div
            className="progress-bar bg-success"
            style={{ width: `${progress * 100}%`, fontSize: '1rem' }}
          >
            {progress * 100}%
          </div>
        </div>

        <div className="text-center">
          <p>{(file.size / 1000000).toFixed(2)} MB Complete</p>
        </div>

        <div className="d-flex justify-content-around">
          {onSave && (
            <button className="btn btn-primary" onClick={onSave}>
              <span>
                <IoSave />
              </span>{' '}
              Save to list
            </button>
          )}

          {onPlay && (
            <button className="btn btn-primary" onClick={onPlay}>
              <span>
                <IoPlay />
              </span>
              Play now
            </button>
          )}
        </div>
      </div>
    );
}
